import { render } from "./CreateOrEdit.vue?vue&type=template&id=4118a4b9&scoped=true"
import script from "./CreateOrEdit.vue?vue&type=script&lang=js"
export * from "./CreateOrEdit.vue?vue&type=script&lang=js"

import "./CreateOrEdit.vue?vue&type=style&index=0&id=4118a4b9&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4118a4b9"]])

export default __exports__